import { createClient } from '@/shared/api';
import type { LogoutMutation, LogoutMutationVariables } from '@/shared/api';
import LOGOUT_MUTATION from '../mutations/logout';

/**
 * Ends the current session on the backend. Builds a client carrying the supplied refresh token, runs LOGOUT_MUTATION and returns the raw mutation result unchecked.
 *
 * @param refreshToken - Refresh token of the session being ended.
 * @returns The raw Apollo mutation result.
 */
const handleLogout = async ({ refreshToken }: { refreshToken?: string }) => {
  const client = createClient({ refreshToken } as Parameters<typeof createClient>[0]);
  const logoutResult = await client.mutate<LogoutMutation, LogoutMutationVariables>({
    mutation: LOGOUT_MUTATION,
  });
  return logoutResult;
};

export default handleLogout;
